import { Intent } from "@blueprintjs/core";
import { ShowHide } from "components/layout";
import { NotificationInline } from "components/notifications";
import PropTypes from "prop-types";
import React, { useState } from "react";

export function GreyFleetInsuranceDocument({
    url = null,
    iframeHeight = "100%"
}) {
    const noDocumentText = "No document provided";
    const brokenLinkText = "The link to the document is broken";
    const [loadError, setLoadError] = useState(false);
    const [triedImage, setTriedImage] = useState(false);

    return (
        <ShowHide
            evaluator={url && url !== ""}
            show={
                <div className="grey-fleet-insurance-document">
                    {!loadError && !triedImage ? (
                        <img
                            alt="Insurance Document"
                            src={url}
                            loading="lazy"
                            onError={() => { setLoadError(false); setTriedImage(true); }}
                        />
                    ) : (
                        <iframe
                            title="Insurance Document"
                            src={url}
                            style={{ width: "100%", height: iframeHeight, border: "none" }}
                            allow="fullscreen"
                            onError={() => setLoadError(true)}
                        />
                    )}
                </div>
            }
            hide={
                <NotificationInline intent={Intent.WARNING} text={loadError ? brokenLinkText : noDocumentText} />
            }
        />
    );
}

GreyFleetInsuranceDocument.propTypes = {
    url: PropTypes.string,
    iframeHeight: PropTypes.string
};
